import { Component, ChangeDetectionStrategy, Input } from "@angular/core";
import { useTranslationNamespace } from "@logex/framework/lg-localization";

@Component({
    selector: "app-organization-status",
    templateUrl: "./organization-status.component.html",
    styleUrls: ["./organization-status.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [useTranslationNamespace("APP._Common")]
})
export class OrganizationStatusComponent {
    @Input() isActive: boolean;
}
